import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e3b25c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card flex-row" }
const _hoisted_2 = { class: "item-minpic" }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = {
  class: "d-flex flex-column",
  style: {"width":"100%"}
}
const _hoisted_5 = { class: "card-body py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        alt: _ctx.data.title,
        src: _ctx.previewPic(_ctx.data.img),
        class: "img-fluid rounded-start"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        style: {"width":"100%"},
        to: { name: 'mod', params: { game: _ctx.data.game, slug: _ctx.data.slug }},
        class: "card-header card-link text-wrap"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.sliceTitle(_ctx.data.title)), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("small", null, "Загружено • " + _toDisplayString(_ctx.getStringTimestamp(_ctx.data.timestamp, true)), 1)
      ])
    ])
  ]))
}